import { Box, Typography } from '@mui/material';

const LearnMoreContent = () => {
  return (
    <Box>
      <Box sx={{ marginBottom: '16px' }}>
        <Typography variant="subheadMedium">
          How to address member needs
        </Typography>
      </Box>
      <Box>
        <Typography variant="bodyLarge">
          Reema takes an individualized approach to addressing member needs
          using our scope of services. Every need will have actions taken toward
          resolution.
        </Typography>
      </Box>
    </Box>
  );
};

export default LearnMoreContent;
